export default __webpack_public_path__ + "static/media/ordinance.996cfb53.pdf";